import {
  GET_FIMLAB_LABORATORIES,
  GET_FIMLAB_LABORATORIES_FAILED,
  RECEIVE_FIMLAB_LABORATORIES,
} from './actions';

const initialState = {
  data: [],
  isFetching: false,
  error: null,
};

const fimlabReducer = (state = initialState, action) => {
  let { type, payload } = action;
  switch (type) {
    case GET_FIMLAB_LABORATORIES: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case RECEIVE_FIMLAB_LABORATORIES: {
      return {
        ...state,
        isFetching: false,
        ...payload,
      };
    }
    case GET_FIMLAB_LABORATORIES_FAILED: {
      return {
        ...state,
        isFetching: false,
        ...payload,
      };
    }
    default:
      return state;
  }
};

export { fimlabReducer };
